<template>
  <PopupContent>
    <PopupTitle>Бонуси</PopupTitle>
    <InfoRow>
      <h4>Ваш баланс</h4>
      <p class="balance-value">{{ hideBalance ? '_' : formatBalance(balance) }} <BalanceBonusIcon class="ml-2" /></p>
    </InfoRow>
    <Divider type="horizontal" />
    <InfoRow>
      <ActionButton
        v-if="!hideBalance"
        @click="$emit('toggle-balance-visibility', false)"
      >
        <HideBalanceIcon class="mr-2" />
        Сховати баланс
      </ActionButton>
      <ActionButton
        v-else
        @click="$emit('toggle-balance-visibility', true)"
      >
        <ShowBalanceIcon class="mr-2" />
        Показати баланс
      </ActionButton>
    </InfoRow>
    <Divider type="horizontal" />
    <InfoRow>
      <TextBlock class="info-text">Бонусні бали - віртуальні облікові одиниці, які нараховуються при виконанні певних дій та якими можна розраховуватись
        виключно на платформі UConnect. З повним переліком правил бонусної системи можна ознайомитись за
        <SmartLink :url="bonusSystemDetailsLink" target="_blank" class="">посиланням</SmartLink>.</TextBlock>
    </InfoRow>
  </PopupContent>
</template>

<script>
import { balanceFormatter } from '@/shared/lib/balance';
import { Divider } from '@/shared/ui/divider';
import {
  BalanceBonusIcon,
  HideBalanceIcon,
  ShowBalanceIcon
} from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';
import { ActionButton, InfoRow, PopupContent, PopupTitle, TextBlock } from '@/shared/ui/popup';

export default {
  props: {
    bonusSystemDetailsLink: {
      type: String,
      default: '',
      required: true,
    },
    balance: {
      type: Number,
      default: 0,
      required: false,
    },
    hideBalance: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [balanceFormatter],
  components: { HideBalanceIcon, ShowBalanceIcon, Divider, BalanceBonusIcon, PopupContent, PopupTitle,
    SmartLink, ActionButton, TextBlock, InfoRow },
};
</script>

<style lang="scss" scoped>
p {
    margin: 0;
}

.balance-value {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.info-text {
  max-width: 300px;
  text-align: justify;

  a {
    text-decoration: underline;
  }
}
</style>
